export default __webpack_public_path__ + "static/media/competition_bg_header.1f84e85b.png";